export default {
    INITIALIZE_PROFILE: "initializeProfile",
    INITIALIZE_AGREEMENTS: 'initializeAgreements',
    INITIALIZE_CARD_INFO: 'initializeCardInfo',
    INITIALIZE_PROFILE_SPECIFY: 'initializeProfileSpecify',
    INITALIZE_DIABETES_REQUEST: 'initalizeDiabetesRequest',
    TEMP_SAVE_DIABETES: 'tempSaveDiabetes',
    FETCH_TEMP_SAVE_DIABETES: 'fetchTempSaveDiabetes',
    SAVE_FIRST_DIABETES: 'saveFirstDiabets',
    SAVE_REVISIT_DIABETES: 'saveRevisitDiabetes',
    CHECK_DIABETES_EXISTS: 'checkDiabetesExists',
    INITIALIZE_NEW_REQUEST_DATA: 'initializeNewRequestData',
    INITIALIZE_REVISIT_REQUEST_DATA: 'initializeRevisitRequestData',
    INITALIZE_TEMP_CONTRACT: 'initalizeTempContract',
    INITIALIZE_FILES: 'initializeFiles',
    SIGNIN_DIABETES_USER: 'signinDiabetesUser',
    SIGNIN_AGREEMENT: 'signinAgreement',
    FETCH_DIABETES_USER_PROFILES: 'fetchDiabetesUserProfiles',
    UPDATE_DIABETES_USER_CARD: 'updateDiabetesUserCard',
    INITIALIZE_CARDCHANGE_REQUEST: 'initializeCardchangeRequest',
    SAVE_FILE: 'saveFile',
    FETCH_DIABETES_HISTORY: 'fetchDiabetesHistory',
    FETCH_DIABETES_DOCUMENT: 'fetchDiabetesDocument',
    SEARCH_DIABETES_PHARMACY: 'searchDiabetesPharmacy',
    SET_SHARED_PHARMACY: 'setSharedPharmacy',
    SET_CHECKED_PHARMACY: 'setCheckedPharmacy',
    SET_PHARMACY_MEDICINE_FILTER: 'setPharmacyMedicineFilter',
    SET_PHARMACY_USER_LOCATION: 'setPharmacyUserLocation',
    FETCH_DIABETES_VOC_PAGE: 'fetchDiabetesVocPage',
    ADD_DIABETES_VOC: 'addDiabetesVoc',
    UPDATE_DIABETES_VOC: 'updateDiabetesVoc',
    INITIALIZE_DIABETES_VOC: 'initializeDiabetesVoc',
    SET_VOC_LOGIN_KAKAO_TOKEN: 'setVocLoginKakaoToken',
    UPDATE_DIABETES_USER_DELIVERY: 'updateDiabetesUserDelivery',
    FETCH_DIABETES_SETTLEMENT: 'fetchDiabetesSettlement',

    // v2 home
    SIGNIN_KAKAO: 'signinKakao',
    SIGNIN_AGREEMENT: 'signinAgreement', 
    FETCH_PROFILES: 'fetchProfiles',
    FETCH_EXPECTED_DATE: 'fetchExpectedDate',
    // 처음 위임장 요청    
    ADD_DRAFT_PROFILE: 'addDraftProfile',
    SAVE_DELEGATE_WITH_ADDITION: 'saveDelegateWithAddition',
    SAVE_DELEGATE_FALSE: 'saveDelegateFalse',
    SAVE_CARD: 'saveCard',
    REGISTER_PROFILE: 'registerProfile',
    // 환자정보
    FETCH_PROFILE: 'fetchProfile',
    UPDATE_PROFILE: 'updateProfile',
    UPDATE_CARD: 'updateCard',
    DELETE_CARD: 'deleteCard',
    UPDATE_DELIVERY: 'updateDelivery',
    SAVE_DELEGATE: 'saveDelegate',
    SAVE_DELEGATE_ADDTION: 'saveDelegateAddition',
    // 서류 정보 
    FETCH_USAGE: 'fetchUsage',
    FETCH_DOCUMENTS: 'fetchDocuments',
    FETCH_YEAR_TAX: 'fetchYearTax',
    
    INITIALIZE_DRAFT_PROFILE: 'initializeDraftProfile',
    INITIALIZE_DELEGATE_WITH_ADDITION: 'initializeDelegateWithAddition',
    INITIALIZE_CARD_INFO: 'initializeCardInfo',
    INITIALIZE_DELIVERY: 'initializeDelivery',
    FETCH_PRE_DELEGATION_INFO: 'fetchPreDelegationInfo',
    // 친구 추천
    FETCH_INVITE_CODE: 'fetchInviteCode',
    APPLY_INVITE_CODE: 'applyInviteCode',
    FETCH_INVITE_FRIENDS: 'fetchInviteFriends'
}



// WEBPACK FOOTER //
// ./src/constant.js